var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentComponentName,_vm._g(_vm._b({tag:"component",staticClass:"cms-components",attrs:{"currentComponentName":_vm.componentsName}},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }